import { render } from "./FilesPreview.vue?vue&type=template&id=5b2bea0c&ts=true"
import script from "./FilesPreview.vue?vue&type=script&lang=ts"
export * from "./FilesPreview.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./FilesPreview.vue?vue&type=style&index=0&id=5b2bea0c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__